import { useState } from 'react';
import {
  View,
  TouchableOpacity,
  StyleSheet,
  LayoutAnimation,
  Platform,
  UIManager,
} from 'react-native';
import { CaretUp, CaretDown } from '../../sharedComponents/Icons';
import gs from '../../styles/globalStyles';
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from '@app/theme';

const Accordion = ({ id, description, title } : {id: string, description: string, title: string}) => {
  const [expanded, setExpanded] = useState(false);
  if (Platform.OS === 'android') {
    UIManager.setLayoutAnimationEnabledExperimental(true);
  }
  const toggleExpand = () => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setExpanded(prevState => !prevState);
  };

  return (
    <ThemedView bg='bg-surface-primary' key={id}>
      <ThemedPressable flexDirection='row' justifyContent='space-between' alignItems='center' backgroundColor='bg-surface-primary'  onPress={toggleExpand}>
        <ThemedView flex={1}>
          <ThemedText variant='b3s' color='text-primary'>{title}</ThemedText>
        </ThemedView>
        {expanded ? (
          <CaretUp size={14} color={themeColorSet['icon-primary']} weight="bold" />
        ) : (
          <CaretDown size={14} color={themeColorSet['icon-primary']} weight="bold" />
        )}
      </ThemedPressable>
      {expanded && (
        <ThemedView mt='sm'>
          <ThemedText variant='b4r' color='text-secondary'>{description.replace('${tenure}',12)}</ThemedText>
        </ThemedView>
      )}
      <ThemedView height={1} bg='border-secondary' marginVertical='lg' />
    </ThemedView>
  );
};

export default Accordion;

const styles = StyleSheet.create({
  title: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fff',
  },
  child: {
    backgroundColor: '#fff',
    padding: 16,
  },
});
